import { render, staticRenderFns } from "./AppointmentsAdminTable.vue?vue&type=template&id=2ff8d5a0&"
import script from "./AppointmentsAdminTable.vue?vue&type=script&lang=js&"
export * from "./AppointmentsAdminTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports